import React, { createContext, useContext, useEffect, useState } from "react";
import { api, authStore, setOn401 } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [status, setStatus] = useState("checking"); // checking | authed | guest
  const [user, setUser] = useState(null);

  useEffect(() => {
    setOn401(() => {
      authStore.clear();
      setUser(null);
      setStatus("guest");
    });
    (async () => {
      if (!authStore.get()) {
        setStatus("guest");
        return;
      }
      try {
        const u = await api.me();
        setUser(u);
        setStatus("authed");
      } catch {
        authStore.clear();
        setStatus("guest");
      }
    })();
  }, []);

  const login = async (email, password) => {
    const res = await api.login(email, password);
    authStore.set(res.access_token);
    setUser(res.user);
    setStatus("authed");
    return res.user;
  };

  const refresh = async () => {
    try {
      const u = await api.me();
      setUser(u);
      setStatus("authed");
    } catch {
      authStore.clear();
      setStatus("guest");
    }
  };

  const logout = () => {
    authStore.clear();
    setUser(null);
    setStatus("guest");
  };

  return (
    <AuthContext.Provider value={{ status, user, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
